import { render, staticRenderFns } from "./DocumentDetailsListing.vue?vue&type=template&id=4983b4e2&"
import script from "./DocumentDetailsListing.vue?vue&type=script&lang=js&"
export * from "./DocumentDetailsListing.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDetailsListing.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DocumentDetailsListing.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports